import "./RL16SlipSetupStyle.css";

import {
  BackdropCircularProgress,
  DeleteConfirmationDialog,
  EnhancedDropDownRHFWithLabel,
  EnhancedSnackbar,
  IEnhancedDropDownItem,
  ITest,
  LabelPosition,
  StandardPanel,
  TwoColumnLayout,
} from "@websential/cosmic";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import {
  FilingDataSetupFieldsPanel,
  RL16SlipDataPanel,
  VendorAddressSetupFieldsPanel,
  VendorInfoSetupFieldsPanel,
} from "./Panels";
import { FormProvider, useForm } from "react-hook-form";
import {
  GET_QUERY_KEY,
  INITIAL_SNACKBAR_DATA,
  QUERY_OPTIONS,
  RL16_SETUP_SCREEN_SLUG,
  T3_BENEFICIARY_RESOURCE_LITERAL,
  VENDOR_RESOURCE_LITERAL,
} from "../../../common/constants";
import { IResponse, IServerError } from "../../../models/common";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";

import { Avatar } from "primereact/avatar";
import Card from "@mui/material/Card";
import { ClientService } from "../../../services";
import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { EnhancedDialog } from "@websential/cosmic";
import FileSaver from "file-saver";
import { FilteredSelectedOtherInfoRL16 } from "./Panels/OtherInformationSetupFieldsPanel";
import { IAppState } from "../../../store/reducers";
import { ICountryReferenceModel } from "../../../models/country/ICountryReferenceModel";
import { IDropDownListResponse } from "../../../models/common/IDropDownListResponse";
import { IRL16SlipRequestPayload } from "../../../models/rl16Slip/IRL16SlipRequestPayload";
import { InputText } from "primereact/inputtext";
import { InvoiceDialogPanel } from "../../../components/T4Slip/T4SlipList/InvoiceDialogPanel";
import NativeSelect from "@mui/material/NativeSelect";
import { PrintingService } from "../../../services/PrintingService";
import { RL16OtherInformationService } from "../../../components/OtherInformation/otherInformations";
import { RL16SlipService } from "../../../services/RL16SlipService";
import { RL16SlipSetupToolbar } from "./RL16SlipSetupToolbar";
import { RL16SlipSetupValidationSchema } from "./validator";
import { ReportsService } from "../../../services/ReportsService";
import { T4SlipService } from "../../../services/T4SlipService";
import { TaxSlipSettingsService } from "../../../services/TaxSlipSettingsService";
import { format } from "date-fns";
import { instanceOfIRL16SlipResponce } from "../../../common/instance-method";
import { setSelectedActivityLogActions } from "../../../store/actions/activityLogActions";
import { setSelectedINVOICE } from "../../../store/actions";
import { setSelectedStickyNavBar } from "../../../store/actions/stickyNavBarActions";
import { yupResolver } from "@hookform/resolvers/yup";

// import { Card } from "primereact/card";
























export let selectedRL16SlipType: any = 400;
export interface IRL16SlipSetup extends ITest { }

const SINGLE_RECORD_DATA_QUERY_KEY = "rl16-slips-single-data-record";
const SINGLE_Employee_DATA_QUERY_KEY = "employee-data";
const EMPLOYEE_DDL_DATA_QUERY_KEY = "employee-ddl-data-record";


// const useGetRL16DDLItems = (clientId: string, dataRole: string, taxYear: number, type: number) =>
//   useQuery({
//     queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, dataRole, taxYear, type],
//     queryFn: (data) => {
//       return RL16SlipService.getRL16RecipientDDLByRecipientType(
//         clientId,
//         T3_BENEFICIARY_RESOURCE_LITERAL,
//         taxYear,
//         type
//       );
//     },
//     refetchOnWindowFocus: false,
//   });

const useGetEmployeeDDLItems = (clientId: string, dataRole: string, taxYear: number) =>
  useQuery({
    queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, dataRole, taxYear],
    queryFn: (data) => {
      return T4SlipService.getEmployeeDDL(clientId, dataRole, taxYear);
    },
    refetchOnWindowFocus: false,
  });
const useGetData = (
  id: string | undefined,
  clientId: string,
  taxYear: number
) => useQuery({
  queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, id],
  queryFn: () => { return RL16SlipService.getRL16SlipById(id, clientId, taxYear) },
  refetchOnWindowFocus: false
});

const useGetForeingCurrencyDDL = () =>
  useQuery({
    queryKey: [""],
    queryFn: (data) => {
      return RL16SlipService.getForeingCurrencyDDL();
    },
    refetchOnWindowFocus: false
  });

const useGetResourceInformationById = (
  resourceId: string,
  clientId: string,
  roleName: string
) => useQuery({
  queryKey: [SINGLE_Employee_DATA_QUERY_KEY, resourceId, clientId, roleName],
  queryFn: () => { return RL16SlipService.getResourceInformationById(resourceId, clientId, roleName) },
  refetchOnWindowFocus: false
});

const parseJSONLikeString = (str: string) => {
  // Use regular expressions to add double quotes around keys and string values
  const modifiedString = str.replace(/(\w+):/g, '"$1":').replace(/'/g, '"');

  // Convert the modified JSON string to an object using JSON.parse()
  return JSON.parse(modifiedString);
};
// const useGetGlobalVariables = (taxYear: number) =>
//   useQuery({
//     queryKey: [GET_QUERY_KEY.GET_GLOBAL_VARIABLES_BY_YEAR, taxYear],
//     queryFn: (data) => {
//       return TaxSlipSettingsService.getGlobalVariables(taxYear);
//     },
//     refetchOnWindowFocus: false
//   });

// const useGetSlipIds = (
//   tag: string,
//   clientId: string,
//   taxYear: number
// ) =>
//   useQuery({
//     queryKey: ["get-slip-ids", tag, clientId, taxYear],
//     queryFn: (data) => {
//       return T4SlipService.getSlipIds(tag, clientId, taxYear);
//     },
//     refetchOnWindowFocus: false
//   });

// const useGetCompanyData = (id: string | undefined) =>
//   useQuery({
//     queryKey: ["client-get-by-id", id],
//     queryFn: (data) => {
//       return ClientService.getById(id);
//     },
//     refetchOnWindowFocus: false
// });

export const RL16SlipSetup: FC<IRL16SlipSetup> = ({ testId }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clientId = useSelector((state: IAppState) => state.client.id);
  const [snackbarData, setSnackbarData] = useState<any>(INITIAL_SNACKBAR_DATA);
  const taxYear = useSelector((state: IAppState) => state.taxYear.year);
  const [selectedResource, setSelectedResource] = useState("create-new");
  const [selectedResourceSlip, setSelectedResourceSlip] =
    useState("create-new");
  const [invoicePaymentFor, setInvoicePaymentFor] = useState(10)
  const dashboardApiData = useSelector((state: IAppState) => state.dashboardApisData);
  const [onResourceSelectionAPIsCalls, setOnResourceSelectionAPIsCalls] =
    useState(false);

  const [selectedResourceSlipList, setSelectedResourceSlipList] = useState<
    IDropDownListResponse[]
  >([{ label: "Create New", value: "create-new" }]);
  const [openInvoiceDialog, setInvoiceDialogOpen] = useState(false);
  const [invoiceData, setInvoiceData] = useState<any>([]);
  const [isLoadingDataa, setIsLoadingData] = useState(false);

  const [selectedResourceList, setSelectedResourceList] = useState<
    IDropDownListResponse[]
  >([{ label: "Create New", value: "create-new" }]);

  const [isLoadingAdjustedData, setIsLoadingAdjustedData] = useState(false);
  const [editedResourceId, setEditedResourceId] = useState("");
  // for delete row
  const [openDialog, setDialogOpen] = useState(false);
  const [apiAction, setApiAction] = useState("");
  const [singleDelete, setSingleDelete] = useState<boolean>(false);
  const [RL16SlipId, setRL16SlipId] = useState<any>("");
  const clientName = useSelector((state: IAppState) => state.client.clientName);
  const isLoadingActivityLogData = useSelector(
    (state: IAppState) => state.isLoadAxiosCall.isLoading
  );

  const [resourceListWithoutCreateNew, setResourceListWithoutCreateNew] =
    useState<any>(undefined);
  const [secondRecipientDDL, setSecondRecipientDDL] = useState<any>(undefined);
  const [selectedCard, setSelectedCard] = useState<any>(null);
  const [itemSearch, setItemSearch] = useState("");
  const [sidePanelsVisibility, setSidePanelsVisibility] = useState(true);
  const [
    selectedSecondRecipientResourceActualIdValue,
    setSelectedSecondRecipientResourceActualIdValue,
  ] = useState<any>(undefined);
  const [recipientTypeValue, setRecipientTypeValue] = useState<any>(undefined);

  //one state which store both new cretaed and edited slip data
  const [RL16SlipRecord, setRL16SlipRecord] = useState<any>(undefined);
  // when  I setValue of otherinformation inside async calls method then facing issue while click on add more so we have to use state method to show otherinformation 
  const [slipOtherInformation, setSlipOtherInformation] =
    useState<any>([]);

  const [selectedOtherInformation, setSelectedOtherInformation] =
    useState(false);
  const [oiInEdit, setOiInEdit] = useState(false);

  // const queryClient = useQueryClient();


  const [CountryResponse] = useState<ICountryReferenceModel>({
    id: 1,
    name: "Canada",
    shortCode: "CAN",
  });

  // for edit
  const queryClient = useQueryClient();
  const { id } = useParams();

  let notStartedSlipId = "";
  let completedSlipId = "";
  if (id !== undefined && onResourceSelectionAPIsCalls === false) {
    if (id?.length > 24) {
      notStartedSlipId = id;
    }
    if (id?.length === 24) {
      completedSlipId = id;
    }
  }

  const DEFAULT_VALUES = {
    clientId: clientId,
    taxYear: taxYear,
  };

  // Function to sort the data array by the label field
  // sort side cards items 
  const sortData = (data: IDropDownListResponse[]): IDropDownListResponse[] => {
    return data.sort((a, b) => a.label.localeCompare(b.label));
  };

  const { isPending: isSubmitting, mutate: submitFlexFields } = useMutation({
    mutationFn: RL16SlipService.create,

    onSuccess: (
      res: IRL16SlipRequestPayload | IServerError | IResponse | any
    ) => {
      if (res.data && instanceOfIRL16SlipResponce(res.data)) {
        queryClient.invalidateQueries({ queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, res.data.id] });
        formMethods.setValue("id", res.data.id);
        setSnackbarData({
          open: true,
          message: "Data has been submitted successfully!",
          severity: "success",
        });
        // refectchRL16SlipIds()
        if (res.status === 201 && selectedResourceSlip === "create-new") {
          (async () => {
            try {

              const response: any =
                await RL16SlipService.getResourceSlipDropDownList(
                  res.data?.resource?.externalId,
                  clientId,
                  taxYear
                );
              if (response && Array.isArray(response)) {
                let resourceSlipList: IDropDownListResponse[] =
                  response.map((resourceSlip: IDropDownListResponse) => ({
                    label: resourceSlip.label,
                    value: resourceSlip.value,
                  }));

                resourceSlipList.unshift({
                  label: "Create New",
                  value: "create-new",
                });


                setSelectedResourceSlipList(resourceSlipList);
                formMethods.setValue(
                  "selectedSlip",
                  res.data.id
                );
                // createNewActionFromSlipDDL();
                // formMethods.setValue("comparison", [
                //   { amount: 0, code: "", label: "" },
                // ]);
                let path = `/taxslip/rl16/setup/${res.data.id}`;
                navigate(path);
              }
            } catch (error) {
              console.error("Error fetching data:", error);
            }
          })();
          setOnResourceSelectionAPIsCalls(true)
          setSelectedResourceSlip(res.data.id)
        }
      } else {
        setSnackbarData({
          open: true,
          // message: "Something went wrong, try again later!",
          message: res.message ? res.message : res.data.message,
          severity: "error",
        });
      }
      //Load RL16 Recipient DDL
      // const fetchData = async () => {
      //   const recipientType = formMethods.getValues("recipientType");
      //   try {
      //     const response: any =
      //       await RL16SlipService.getRL16RecipientDDLByRecipientType(
      //         clientId,
      //         T3_BENEFICIARY_RESOURCE_LITERAL,
      //         taxYear,
      //         res.recipientType ? res.recipientType : recipientType
      //       );


      //     if (response && Array.isArray(response)) {
      //       let resources: IDropDownListResponse[] = response.map(
      //         (resourceItem: IDropDownListResponse) => ({
      //           // id: resourceItem.id,
      //           label: resourceItem.label,
      //           value: resourceItem.value,
      //         })
      //       );

      //       resources.unshift({
      //         label: "Create New",
      //         value: "create-new",
      //       });

      //       setSelectedResourceList(resources);

      //     }
      //     setResourceListWithoutCreateNew(sortData(response));
      //   } catch (error) {
      //     console.error("Error fetching data:", error);
      //   }
      // };

      // fetchData();

      // const recipientType = formMethods.getValues("recipientType");
      // queryClient.invalidateQueries({
      //   queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId,
      //     T3_BENEFICIARY_RESOURCE_LITERAL,
      //     taxYear,
      //     res.recipientType ? res.recipientType : recipientType],
      // });
      queryClient.invalidateQueries({
        queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, T3_BENEFICIARY_RESOURCE_LITERAL, taxYear],
      });
      setSelectedCard(String(res.data.resource.externalId));
      formMethods.setValue(
        "selectedEmployee",
        res.data.resource.externalId
      );
      setSelectedResource(res.data.resource.externalId);
      //load slip Data
      if (res.data && res.data?.resource) {
        setRL16SlipRecord(res.data);
        setSelectedResource(res.data?.resource?.externalId);
      }
      selectedRL16SlipType = formMethods.getValues("slipType");
      setSelectedOtherInformation(true);
    },
    onError: (err: any) => {
      setSnackbarData({
        open: true,
        message: err.message,
        severity: "error",
      });
    },
  }
  );

  const [isPendingSlipData, setIsPendingSlipData] = useState(false);
  //when cretae-new seleted from slip ddl
  const createNewActionFromSlipDDL = () => {
    // setSelectedOtherInformation(true);
    setSelectedOtherInformation(false);
    setRL16SlipRecord(undefined)
    setSelectedResourceSlip("create-new");
    formMethods.setValue(
      "selectedSlip",
      "create-new"
    );
    formMethods.setValue("capitalGains", "0.00");
    formMethods.setValue("singlePensionPayment", "0.00");
    formMethods.setValue("actualAmountOfEligibleDivinends", "0.00");
    formMethods.setValue("actualAmountOfDivinendsOtherThanEligible", "0.00");
    formMethods.setValue("pensionPaymentGivingEntitlement", "0.00");
    formMethods.setValue("foreignBusinessIncome", "0.00");
    formMethods.setValue("foreignNonBusinessIncome", "0.00");
    formMethods.setValue("otherIncome", "0.00");
    formMethods.setValue("capitalGainGivingEntitlement", "0.00");
    formMethods.setValue("taxableAmountOfEligibleAndOrdinaryDividends", "0.00");
    formMethods.setValue("dividendTaxCredit", "0.00");
    formMethods.setValue("foreignIncomeTaxOnBusinessIncome", "0.00");
    formMethods.setValue("foreignIncomeTaxOnNonBusinessIncome", "0.00");
    formMethods.setValue("costBasedAdjustmentOfCapitalInterest", "0.00");
    formMethods.setValue("donationFromAReligiousOrganization", "0.00");
    formMethods.setValue("beneficiaryNumber", "");
    formMethods.setValue("consolidatedIndicator", 'C');
    formMethods.setValue("footNotes", "");
    formMethods.setValue("optionalTextToPrintOnTheSlip", "");
    formMethods.setValue("slipStatus", 200);
    formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
    // setSlipOtherInformation([])
    setSlipOtherInformation([{ amount: 0, code: 'null', label: 'Empty Field' }])
  };

  const resourceDataByIdPass = useCallback(
    (resourceDataById: any) => {
      if (resourceDataById) {
        setIsPendingSlipData(true);
        Object.keys(resourceDataById).forEach((fieldName) => {
          // @ts-ignore
          const fieldValue = resourceDataById[fieldName];

          formMethods.setValue(fieldName, fieldValue);

          if (fieldName === "email") {
            if (fieldValue !== null) {
              formMethods.setValue(fieldName, fieldValue);
            } else {
              // const maskedStatus: any = sessionStorage.getItem("maskEnabled");
              if (dashboardApiData.masked_status) {
                formMethods.setValue(fieldName, "ze*****3@gmail.com");
              } else {
                formMethods.setValue(fieldName, "");
              }
            }
          }
          if (fieldName === "address") {
            Object.keys(fieldValue).forEach((resourceFieldName) => {
              const resourceFieldValue = fieldValue[resourceFieldName];
              // @ts-ignore


              Object.keys(resourceFieldValue).forEach((resourceFieldNameNew) => {
                const resourceFieldValueNew =
                  resourceFieldValue[resourceFieldNameNew];
                // @ts-ignore

                formMethods.setValue(resourceFieldNameNew, resourceFieldValueNew);

                if (resourceFieldNameNew === "country") {
                  formMethods.setValue(
                    resourceFieldNameNew,
                    resourceFieldValueNew.name ?? undefined
                  );
                }
                if (resourceFieldNameNew === "province") {
                  let id = resourceFieldValueNew.id;
                  let name = resourceFieldValueNew.name;
                  let shortCode = resourceFieldValueNew.shortCode;



                  formMethods.setValue(
                    resourceFieldNameNew,
                    `{id:${id}, name: "${name}",shortCode:"${shortCode}"}`
                    // '{id:1, name: "Alberta",shortCode:"AB"}'
                  );
                }
              });
            });
          }
          if (fieldName === "id" && onResourceSelectionAPIsCalls === false) {
            //for auto selected card
            setSelectedCard(String(fieldValue));
            formMethods.setValue(
              "selectedVendor",
              fieldValue
            );
            setSelectedResource(fieldValue);
          }
          if (fieldName === "uniqueIdentifier") {
            const formattedNumber =
              fieldValue !== null
                ? fieldValue.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3")
                : undefined;
            formMethods.setValue("uniqueIdentifier", formattedNumber);
          }

          if (fieldName === "firstName") {
            formMethods.setValue(
              "firstName",
              fieldValue !== null ? fieldValue : undefined
            );
          }
          // }
          if (fieldName === "metaFields") {
            fieldValue.forEach((obj: any) => {
              formMethods.setValue(obj.name, obj.value);
              if (obj.name === "initial") {
                formMethods.setValue("initials", obj.value);
              }
              if (obj.name === "recipientType") {
                formMethods.setValue(obj.name, parseInt(obj.value));
              }

            });
          }
        });
        createNewActionFromSlipDDL();
        setIsPendingSlipData(false);
      }
    },
    [onResourceSelectionAPIsCalls]
  );

  // slipDataById in function
  const slipDataByIdPass = useCallback(
    (slipDataById: any, onResourceSelectionAPIsCalls: boolean) => {
      setIsPendingSlipData(true);
      if (slipDataById) {
        Object.keys(slipDataById).forEach(
          (fieldName) => {

            // @ts-ignore
            const fieldValue =
              slipDataById[fieldName];

            // @ts-ignore

            if (
              typeof fieldValue !== "object"
            ) {
              // @ts-ignore
              formMethods.setValue(
                fieldName,
                fieldValue ?? undefined
              );
            } else if (
              fieldValue !== null ||
              undefined
            ) {

              Object.keys(fieldValue).forEach(
                (objFieldName: any) => {

                  // @ts-ignore
                  const objFieldValue =
                    fieldValue[objFieldName];



                  if (
                    typeof objFieldValue !==
                    "object"
                  ) {
                    // @ts-ignore
                    formMethods.setValue(
                      objFieldName,
                      objFieldValue
                    );
                  }
                  if (
                    fieldName === "resource"
                  ) {
                    if (
                      objFieldName ===
                      "externalId"
                    ) {

                      //  
                      //for auto selected card
                      setSelectedCard(
                        String(
                          objFieldValue
                        )
                      );
                      formMethods.setValue(
                        "selectedVendor",
                        objFieldValue
                      );
                      if (!onResourceSelectionAPIsCalls) {
                        (async () => {
                          try {
                            const response: any =
                              await RL16SlipService.getResourceSlipDropDownList(
                                objFieldValue,
                                clientId,
                                taxYear
                              );

                            // formMethods.setValue("selectedSlip", response[0].value);

                            if (
                              response &&
                              Array.isArray(
                                response
                              )
                            ) {
                              let resourceSlipList: IDropDownListResponse[] =
                                response.map(
                                  (
                                    resourceSlip: IDropDownListResponse
                                  ) => ({
                                    label:
                                      resourceSlip.label,
                                    value:
                                      resourceSlip.value,
                                  })
                                );

                              resourceSlipList.unshift(
                                {
                                  label:
                                    "Create New",
                                  value:
                                    "create-new",
                                }
                              );


                              setSelectedResourceSlipList(
                                resourceSlipList
                              );
                              //for Cards scenario
                              if (
                                resourceSlipList &&
                                resourceSlipList.length >
                                1
                              ) {
                                setSelectedResourceSlip(
                                  String(id)
                                );
                              } else {
                                setSelectedResourceSlip(
                                  "create-new"
                                );
                              }
                            }
                          } catch (error) {
                            console.error(
                              "Error fetching data:",
                              error
                            );
                          }
                        })();
                        setSelectedResource(
                          objFieldValue
                        );
                      }
                    }
                    setEditedResourceId(
                      fieldValue.externalId
                    );
                    if (
                      objFieldName === "email"
                    ) {
                      if (
                        objFieldValue !== null
                      ) {
                        formMethods.setValue(
                          objFieldName,
                          objFieldValue
                        );
                      } else {
                        // const maskedStatus: any =
                        //   sessionStorage.getItem(
                        //     "maskEnabled"
                        //   );

                        if (
                          dashboardApiData.masked_status
                        ) {
                          formMethods.setValue(
                            objFieldName,
                            "ze*****3@gmail.com"
                          );
                        } else {
                          formMethods.setValue(
                            objFieldName,
                            ""
                          );
                        }
                      }
                    }
                  }
                  if (
                    objFieldName === "province"
                  ) {
                    let id = objFieldValue.id;
                    let name =
                      objFieldValue.name;
                    let shortCode =
                      objFieldValue.shortCode;


                    formMethods.setValue(
                      objFieldName,
                      // '{id:9, name: "Ontario",shortCode:"ON"}'
                      `{id:${id}, name: "${name}",shortCode:"${shortCode}"}`
                    );
                  }
                  if (
                    objFieldName === "country"
                  ) {
                    formMethods.setValue(
                      objFieldName,
                      objFieldValue.name ??
                      undefined
                    );
                  }
                  if (
                    objFieldName ===
                    "uniqueIdentifier"
                  ) {
                    const formattedNumber =
                      objFieldValue !== null
                        ? objFieldValue.replace(
                          /(\d{3})(\d{3})(\d{3})/,
                          "$1-$2-$3"
                        )
                        : undefined;
                    formMethods.setValue(
                      "uniqueIdentifier",
                      formattedNumber
                    );
                  }

                }
              );
            }
            //set slip type according to edited row data for submit button action
            if (
              fieldName === "otherInformation"
            ) {
              // setSlipOtherInformation(fieldValue)
              // if (
              //   fieldValue &&
              //   fieldValue !== null &&
              //   fieldValue.length !== 0
              // ) {
              //   setOiInEdit(true);
              //   formMethods.setValue(
              //     "comparison",
              //     fieldValue
              //   );
              // } else {

              //   setOiInEdit(true);
              //   formMethods.setValue(
              //     "comparison",
              //     [
              //       {
              //         amount: 0,
              //         code: "",
              //         label: "",
              //       },
              //     ]
              //   );
              // }
              setSlipOtherInformation([])
              if (fieldValue && fieldValue !== null && fieldValue.length !== 0) {
                setOiInEdit(true);
                formMethods.setValue("comparison", fieldValue);
              } else {
                setOiInEdit(true);
                formMethods.setValue("comparison", [
                  { amount: 0, code: "", label: "" },
                ]);
              }
            }
            if (fieldName === "id") {
              // setNewCreatedSlipId(fieldValue)
              formMethods.setValue(
                "selectedSlip",
                fieldValue
              );
              let path = `/taxslip/rl16/setup/${fieldValue}`;
              navigate(path);
            }
            if (fieldName === "slipData") {
              Object.keys(fieldValue).forEach((slipDataFieldName: any) => {
                const slipDataFieldValue = fieldValue[slipDataFieldName];

                if (
                  slipDataFieldName !==
                  "beneficiaryNumber" &&
                  slipDataFieldName !==
                  "consolidatedIndicator" &&
                  slipDataFieldName !==
                  "footNotes" &&
                  slipDataFieldName !==
                  "optionalTextToPrintOnTheSlip"
                ) {
                  formMethods.setValue(
                    slipDataFieldName,
                    slipDataFieldValue && slipDataFieldValue !== null
                      ? parseFloat(slipDataFieldValue).toFixed(2)
                      : "0.00"
                  );
                } else {
                  formMethods.setValue(
                    slipDataFieldName,
                    slipDataFieldValue
                  );
                }
              });
            }
            if (
              fieldName ===
              "recipientType"
            ) {
              formMethods.setValue(
                "recipientType",
                fieldValue
              );
              // console.log("fieldValue11", fieldValue)
              if (fieldValue === 20) {
                const individual = formMethods.getValues("individual");
                if (individual === false) {
                  (async () => {
                    try {
                      setIsLoadingAdjustedData(true);
                      const response: any =
                        await RL16SlipService.getRL16RecipientDDLByRecipientType(
                          clientId,
                          T3_BENEFICIARY_RESOURCE_LITERAL,
                          taxYear,
                          30
                        );

                      setSecondRecipientDDL(response);
                    } catch (error) {
                      console.error("Error fetching data:", error);
                    } finally {
                      setIsLoadingAdjustedData(false);
                    }
                  })();
                } else if (individual === true) {
                  (async () => {
                    try {
                      setIsLoadingAdjustedData(true);
                      const response: any =
                        await RL16SlipService.getRL16RecipientDDLByRecipientType(
                          clientId,
                          T3_BENEFICIARY_RESOURCE_LITERAL,
                          taxYear,
                          10
                        );

                      setSecondRecipientDDL(response);
                    } catch (error) {
                      console.error("Error fetching data:", error);
                    } finally {
                      setIsLoadingAdjustedData(false);
                    }
                  })();
                }
              }
            }
            if (
              fieldName === "secondExternalId"
            ) {
              if (fieldValue !== null) {
                // (async () => {
                //   try {
                //     const responseAssociationId =
                //       await T4SlipService.getRoleAssociationId(
                //         fieldValue
                //       );
                formMethods.setValue(
                  "secondRecipientName",
                  fieldValue
                );
                //   } catch {}
                // })();
              }
            }
          }
        );
        setIsPendingSlipData(false);
      }
    },
    []
  );


  const {
    isLoading: isLoadingForeignCurrencyDDL,
    data: foreignCurrencyDDList,
  } = useGetForeingCurrencyDDL();

  const foreignCurrencyDDListItems = useMemo(() => {
    if (foreignCurrencyDDList && Array.isArray(foreignCurrencyDDList)) {

      let foreignCurrency: any[] = foreignCurrencyDDList.map(
        (resourceItem: any) => ({
          label: resourceItem.label,
          value: resourceItem.value,
          name: resourceItem.name,
        })
      );
      foreignCurrency.unshift({
        label: "--",
        value: null,
      });

      return foreignCurrency;
    }
  }, [foreignCurrencyDDList]);
  const formMethods = useForm<any>({
    resolver: yupResolver(RL16SlipSetupValidationSchema),
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: DEFAULT_VALUES,
  });

  // const { isPending: isPendingEmployeeDDLItems, data: employeeDDLItems } =
  //   useGetRL16DDLItems(clientId,
  //     T3_BENEFICIARY_RESOURCE_LITERAL,
  //     taxYear,
  //     10);
  const { isPending: isPendingEmployeeDDLItems, data: employeeDDLItems } =
    useGetEmployeeDDLItems(clientId,
      T3_BENEFICIARY_RESOURCE_LITERAL,
      taxYear);

  useEffect(() => {
    if (employeeDDLItems) {
      if (employeeDDLItems && Array.isArray(employeeDDLItems)) {
        let resources: IDropDownListResponse[] = employeeDDLItems.map(
          (resourceItem: IDropDownListResponse) => ({
            // id: resourceItem.id,
            label: resourceItem.label,
            value: resourceItem.value,
          })
        );

        resources.unshift({
          label: "Create New",
          value: "create-new",
        });

        setSelectedResourceList(resources);
      }
      setResourceListWithoutCreateNew(sortData(employeeDDLItems));
    }
  }, [employeeDDLItems])

  // for edit

  //for that slips which are completed
  const { isPending: isLoadingData, data: selectedRL16SlipsData } = useGetData(
    completedSlipId,
    clientId,
    taxYear
  );

  useEffect(() => {
    if (selectedRL16SlipsData) {
      setRL16SlipRecord(selectedRL16SlipsData);
    }
  }, [selectedRL16SlipsData]);


  //for that slips which are not started yet
  const {
    isLoading: isLoadingNotStartedSlipId,
    data: selectedNotStartedResourceData,
    // refetch: refetchResourceSlips,
  } = useGetResourceInformationById(
    notStartedSlipId,
    clientId,
    T3_BENEFICIARY_RESOURCE_LITERAL
  );



  /**
   * Handle when the form is submitted.
   *
   * @param {IRL16SlipRequestPayload} formData
   */
  const onSubmit = (formData: any) => {
    //province is in string format and by using this we convert that in object
    const jsonString = formData.province as string;
    // Custom parsing function to convert the JSON-like string to an object
    const parseJSONLikeString = (str: string) => {
      // Use regular expressions to add double quotes around keys and string values
      const modifiedString = str.replace(/(\w+):/g, '"$1":').replace(/'/g, '"');
      // Convert the modified JSON string to an object using JSON.parse()
      return JSON.parse(modifiedString);
    };
    // Convert the JSON-like string to an object
    const provinceObject = parseJSONLikeString(jsonString);


    //province is in string format and by using this we convert that in object
    // const jsonStringPoe = formData.provinceOfEmployment as string;
    // Custom parsing function to convert the JSON-like string to an object
    // const parseJSONLikeStringPeo = (str: string) => {
    //   // Use regular expressions to add double quotes around keys and string values
    //   const modifiedString = str.replace(/(\w+):/g, '"$1":').replace(/'/g, '"');
    //   // Convert the modified JSON string to an object using JSON.parse()
    //   return JSON.parse(modifiedString);
    // };
    // Convert the JSON-like string to an object
    // const poeObject = parseJSONLikeStringPeo(jsonStringPoe);


    //other Information
    const getValue = formMethods.getValues("comparison");

    const finalOtherInformatioItems = FilteredSelectedOtherInfoRL16.map(
      (item: any) => {
        const valueItem = getValue.find(
          (value: any) => value.code === item.code
        );
        const getLabelIfMissingInItem =
          RL16OtherInformationList &&
          RL16OtherInformationList.find(
            (value: any) => value.value === item.code
          );

        return {
          ...item,
          amount: valueItem.amount,
          label: getLabelIfMissingInItem.label,
        };
      }
    );

    if (
      formData.recipientType === 20 ||
      formData.recipientType === 60 ||
      formData.recipientType === 70
    ) {
      // (async () => {
      //   try {
      //       const selectedSecondRecipientResourceActualId =
      //         await T4SlipService.getResourceActualId(formData.secondRecipientName && formData.secondRecipientName);
      //       setSelectedSecondRecipientResourceActualIdValue(
      //         selectedSecondRecipientResourceActualId
      //       );
      const selectedSecondRacipientObject =
        secondRecipientDDL &&
        secondRecipientDDL.find(
          (item: any) => item.value === formData.secondRecipientName
        );



      const requestPayload: any = {
        clientId: clientId,
        taxYear: taxYear,
        id:
          selectedRL16SlipsData && selectedRL16SlipsData.resource
            ? selectedRL16SlipsData.id
            : RL16SlipRecord && RL16SlipRecord.id ? RL16SlipRecord.id
              : undefined,
        recipientType: formData.recipientType,
        reflectMasterData: formData.reflectMasterData,
        slipType: formData.slipType,
        secondRecipientName:
          formData.recipientType === 20
            ? selectedSecondRacipientObject &&
            selectedSecondRacipientObject.label
            : undefined,
        slipStatus: formData.slipStatus,
        otherInformation:
          formData.comparison[0].code !== "" ? finalOtherInformatioItems : [],
        resource: {
          externalId:
            selectedResource !== "create-new"
              ? selectedResource
              : selectedRL16SlipsData && selectedRL16SlipsData.resource
                ? selectedRL16SlipsData.resource.externalId
                : selectedNotStartedResourceData &&
                  selectedNotStartedResourceData.id
                  ? selectedNotStartedResourceData.id
                  : undefined,
          firstName:
            formData.name1 && formData.name1.length > 0
              ? formData.name1
              : undefined,
          initials: formData.initials,
          lastName:
            formData.name2 && formData.name2.length > 0
              ? formData.name2
              : undefined,
          // dateOfBirth:formData.dateOfBirth,
          socialInsuranceNumber:
            formData.uniqueIdentifier && formData.uniqueIdentifier !== ""
              ? formData.uniqueIdentifier.replace(/-/g, "")
              : undefined,
          address: formData.addressLine1,
          city: formData.city,
          country: CountryResponse,
          postCode:
            formData.postalCode &&
            formData.postalCode.replace(/[a-z]/g, (match: string) =>
              match.toUpperCase()
            ),
          province: provinceObject, //when edit then it show n select so this technique is use bcz we cant assign fieldvalue according to field name by using direct object so first we change that oobject to string then we chnage that string to obj and send to payload
          email: formData.email !== "" && formData.email !== "ze*****3@gmail.com"
            ? formData.email
            : undefined,
        },
        individual: formData.recipientType === 20 && formData.individual,
        slipData: {
          capitalGains: formData.capitalGains && formData.capitalGains !== null ?
            parseFloat(
              formData.capitalGains.replace(/[$,]/g, '')
            ) : 0,
          singlePensionPayment: formData.singlePensionPayment && formData.singlePensionPayment !== null ?
            parseFloat(
              formData.singlePensionPayment.replace(/[$,]/g, '')
            ) : 0,
          actualAmountOfEligibleDivinends: formData.actualAmountOfEligibleDivinends && formData.actualAmountOfEligibleDivinends !== null ?
            parseFloat(
              formData.actualAmountOfEligibleDivinends.replace(/[$,]/g, '')
            ) : 0,
          actualAmountOfDivinendsOtherThanEligible: formData.actualAmountOfDivinendsOtherThanEligible && formData.actualAmountOfDivinendsOtherThanEligible !== null ?
            parseFloat(
              formData.actualAmountOfDivinendsOtherThanEligible.replace(/[$,]/g, '')
            ) : 0,
          pensionPaymentGivingEntitlement: formData.pensionPaymentGivingEntitlement && formData.pensionPaymentGivingEntitlement !== null ?
            parseFloat(
              formData.pensionPaymentGivingEntitlement.replace(/[$,]/g, '')
            ) : 0,
          foreignBusinessIncome: formData.foreignBusinessIncome && formData.foreignBusinessIncome !== null ?
            parseFloat(formData.foreignBusinessIncome.replace(/[$,]/g, '')) : 0,
          foreignNonBusinessIncome: formData.foreignNonBusinessIncome && formData.foreignNonBusinessIncome !== null ?
            parseFloat(
              formData.foreignNonBusinessIncome.replace(/[$,]/g, '')
            ) : 0,
          otherIncome: formData.otherIncome && formData.otherIncome !== null ?
            parseFloat(formData.otherIncome.replace(/[$,]/g, '')) : 0,
          capitalGainGivingEntitlement: formData.capitalGainGivingEntitlement && formData.capitalGainGivingEntitlement !== null ?
            parseFloat(
              formData.capitalGainGivingEntitlement.replace(/[$,]/g, '')
            ) : 0,
          taxableAmountOfEligibleAndOrdinaryDividends: formData.taxableAmountOfEligibleAndOrdinaryDividends && formData.taxableAmountOfEligibleAndOrdinaryDividends !== null ?
            parseFloat(formData.taxableAmountOfEligibleAndOrdinaryDividends.replace(/[$,]/g, '')) : 0,
          dividendTaxCredit: formData.dividendTaxCredit && formData.dividendTaxCredit !== null ?
            parseFloat(formData.dividendTaxCredit.replace(/[$,]/g, '')) : 0,
          foreignIncomeTaxOnBusinessIncome: formData.foreignIncomeTaxOnBusinessIncome && formData.foreignIncomeTaxOnBusinessIncome !== null ?
            parseFloat(formData.foreignIncomeTaxOnBusinessIncome.replace(/[$,]/g, '')) : 0,
          foreignIncomeTaxOnNonBusinessIncome: formData.foreignIncomeTaxOnNonBusinessIncome && formData.foreignIncomeTaxOnNonBusinessIncome !== null ?
            parseFloat(formData.foreignIncomeTaxOnNonBusinessIncome.replace(/[$,]/g, '')) : 0,
          costBasedAdjustmentOfCapitalInterest: formData.costBasedAdjustmentOfCapitalInterest && formData.costBasedAdjustmentOfCapitalInterest !== null ?
            parseFloat(formData.costBasedAdjustmentOfCapitalInterest.replace(/[$,]/g, '')) : 0,
          donationFromAReligiousOrganization: formData.donationFromAReligiousOrganization && formData.donationFromAReligiousOrganization !== null ?
            parseFloat(formData.donationFromAReligiousOrganization.replace(/[$,]/g, '')) : 0,
          beneficiaryNumber: formData.beneficiaryNumber && formData.beneficiaryNumber !== null && formData.beneficiaryNumber !== "" ?
            parseFloat(formData.beneficiaryNumber.replace(/[$,]/g, '')) : undefined,
          consolidatedIndicator: formData.consolidatedIndicator && formData.consolidatedIndicator,
          footNotes: formData.footNotes && formData.footNotes !== '' ? formData.footNotes : undefined,
          optionalTextToPrintOnTheSlip: formData.optionalTextToPrintOnTheSlip && formData.optionalTextToPrintOnTheSlip !== '' ? formData.optionalTextToPrintOnTheSlip : undefined,
        },
        secondExternalId:
          formData.secondRecipientName && formData.secondRecipientName,
      };


      // submitFlexFields(formData);
      submitFlexFields(requestPayload);
      //   } catch (error: any) {
      //     alert(error)
      //   }
      // })();
    } else {
      //   (async () => {
      //   try {
      //    
      //  
      //     let secondRecipient =
      //       formData.secondRecipientName && formData.secondRecipientName;
      //     if (secondRecipient) {
      //       const selectedSecondRecipientResourceActualId =
      //         await T4SlipService.getResourceActualId(secondRecipient);
      //       setSelectedSecondRecipientResourceActualIdValue(
      //         selectedSecondRecipientResourceActualId
      //       );
      //     }
      //   } catch (error: any) {}
      // })();
      const selectedSecondRacipientObject =
        secondRecipientDDL &&
        secondRecipientDDL.find(
          (item: any) => item.value === formData.secondRecipientName
        );



      const requestPayload: any = {
        clientId: clientId,
        taxYear: taxYear,
        id:
          selectedRL16SlipsData && selectedRL16SlipsData.resource
            ? selectedRL16SlipsData.id
            : RL16SlipRecord && RL16SlipRecord.id ? RL16SlipRecord.id
              : undefined,
        recipientType: formData.recipientType,
        reflectMasterData: formData.reflectMasterData,
        slipType: formData.slipType,
        // secondRecipientName:
        //   formData.recipientType === 20
        //     ? selectedSecondRacipientObject && selectedSecondRacipientObject.label
        //     : undefined,
        slipStatus: formData.slipStatus,
        otherInformation:
          formData.comparison[0].code !== "" ? finalOtherInformatioItems : [],
        resource: {
          externalId:
            selectedResource !== "create-new"
              ? selectedResource
              : selectedRL16SlipsData && selectedRL16SlipsData.resource
                ? selectedRL16SlipsData.resource.externalId
                : selectedNotStartedResourceData &&
                  selectedNotStartedResourceData.id
                  ? selectedNotStartedResourceData.id
                  : undefined,
          firstName:
            formData.recipientType === 10 &&
              formData.name1 &&
              formData.name1.length > 0
              ? formData.name1
              : formData.recipientType === 20 &&
                formData.name1 &&
                formData.name1.length > 0
                ? formData.name1
                : undefined,
          initials:
            formData.recipientType === 10
              ? formData.initials
              : formData.recipientType === 20
                ? formData.initials
                : "",
          lastName:
            formData.recipientType === 10 &&
              formData.name2 &&
              formData.name2.length > 0
              ? formData.name2
              : formData.recipientType === 20 &&
                formData.name2 &&
                formData.name2.length > 0
                ? formData.name2
                : undefined,
          // dateOfBirth:formData.dateOfBirth,
          socialInsuranceNumber:
            formData.recipientType === 10 &&
              formData.uniqueIdentifier &&
              formData.uniqueIdentifier !== ""
              ? formData.uniqueIdentifier.replace(/-/g, "")
              : formData.recipientType === 20 &&
                formData.uniqueIdentifier &&
                formData.uniqueIdentifier !== ""
                ? formData.uniqueIdentifier.replace(/-/g, "")
                : undefined,
          address: formData.addressLine1,
          city: formData.city,
          country: CountryResponse,
          postCode:
            formData.postalCode &&
            formData.postalCode.replace(/[a-z]/g, (match: string) =>
              match.toUpperCase()
            ),
          province: provinceObject, //when edit then it show n select so this technique is use bcz we cant assign fieldvalue according to field name by using direct object so first we change that oobject to string then we chnage that string to obj and send to payload
          // provinceOfEmployment: poeObject,
          email: formData.email !== "" && formData.email !== "ze*****3@gmail.com"
            ? formData.email
            : undefined,
          businessName:
            formData.firstLineOfRecipientName +
            formData.secondLineOfRecipientName, //First line of recipient name * Second line of recipient name *
          businessNumber:
            formData.recipientType === 30 && formData.businessNumber !== ""
              ? formData.businessNumber
              : formData.recipientType === 50 && formData.businessNumber !== ""
                ? formData.businessNumber
                : undefined,
        },
        individual: formData.recipientType === 20 && formData.individual,
        trustAccountNumber: formData.recipientType === 40 ?
          formData.trustAccountNumber && formData.trustAccountNumber.charAt(0) === 'T' ? formData.trustAccountNumber : `T${formData.trustAccountNumber}` : undefined,
        firstLineOfRecipientName:
          formData.recipientType === 30 &&
            formData.firstLineOfRecipientName !== ""
            ? formData.firstLineOfRecipientName
            : formData.recipientType === 40 &&
              formData.firstLineOfRecipientName !== ""
              ? formData.firstLineOfRecipientName
              : formData.recipientType === 50 &&
                formData.firstLineOfRecipientName !== ""
                ? formData.firstLineOfRecipientName
                : undefined,
        secondLineOfRecipientName:
          formData.recipientType === 30 &&
            formData.secondLineOfRecipientName !== ""
            ? formData.secondLineOfRecipientName
            : formData.recipientType === 40 &&
              formData.secondLineOfRecipientName !== ""
              ? formData.secondLineOfRecipientName
              : formData.recipientType === 50 &&
                formData.secondLineOfRecipientName !== ""
                ? formData.secondLineOfRecipientName
                : undefined,
        // name3: (formData.recipientType === 20 && formData.individual === false) ? selectedSecondRacipientObject && selectedSecondRacipientObject.label.substring(0, selectedSecondRacipientObject.label.indexOf(' ')) : formData.name3 !== "" ? formData.name3 : undefined,
        // name4: (formData.recipientType === 20 && formData.individual === false) ? selectedSecondRacipientObject && selectedSecondRacipientObject.label.substring(selectedSecondRacipientObject.label.indexOf(' ') + 1) : formData.name4 !== "" ?formData.name4 : undefined,
        // initials1: formData.initials1,
        slipData: {
          capitalGains: formData.capitalGains && formData.capitalGains !== null ?
            parseFloat(
              formData.capitalGains.replace(/[$,]/g, '')
            ) : 0,
          singlePensionPayment: formData.singlePensionPayment && formData.singlePensionPayment !== null ?
            parseFloat(
              formData.singlePensionPayment.replace(/[$,]/g, '')
            ) : 0,
          actualAmountOfEligibleDivinends: formData.actualAmountOfEligibleDivinends && formData.actualAmountOfEligibleDivinends !== null ?
            parseFloat(
              formData.actualAmountOfEligibleDivinends.replace(/[$,]/g, '')
            ) : 0,
          actualAmountOfDivinendsOtherThanEligible: formData.actualAmountOfDivinendsOtherThanEligible && formData.actualAmountOfDivinendsOtherThanEligible !== null ?
            parseFloat(
              formData.actualAmountOfDivinendsOtherThanEligible.replace(/[$,]/g, '')
            ) : 0,
          pensionPaymentGivingEntitlement: formData.pensionPaymentGivingEntitlement && formData.pensionPaymentGivingEntitlement !== null ?
            parseFloat(
              formData.pensionPaymentGivingEntitlement.replace(/[$,]/g, '')
            ) : 0,
          foreignBusinessIncome: formData.foreignBusinessIncome && formData.foreignBusinessIncome !== null ?
            parseFloat(formData.foreignBusinessIncome.replace(/[$,]/g, '')) : 0,
          foreignNonBusinessIncome: formData.foreignNonBusinessIncome && formData.foreignNonBusinessIncome !== null ?
            parseFloat(
              formData.foreignNonBusinessIncome.replace(/[$,]/g, '')
            ) : 0,
          otherIncome: formData.otherIncome && formData.otherIncome !== null ?
            parseFloat(formData.otherIncome.replace(/[$,]/g, '')) : 0,
          capitalGainGivingEntitlement: formData.capitalGainGivingEntitlement && formData.capitalGainGivingEntitlement !== null ?
            parseFloat(
              formData.capitalGainGivingEntitlement.replace(/[$,]/g, '')
            ) : 0,
          taxableAmountOfEligibleAndOrdinaryDividends: formData.taxableAmountOfEligibleAndOrdinaryDividends && formData.taxableAmountOfEligibleAndOrdinaryDividends !== null ?
            parseFloat(formData.taxableAmountOfEligibleAndOrdinaryDividends.replace(/[$,]/g, '')) : 0,
          dividendTaxCredit: formData.dividendTaxCredit && formData.dividendTaxCredit !== null ?
            parseFloat(formData.dividendTaxCredit.replace(/[$,]/g, '')) : 0,
          foreignIncomeTaxOnBusinessIncome: formData.foreignIncomeTaxOnBusinessIncome && formData.foreignIncomeTaxOnBusinessIncome !== null ?
            parseFloat(formData.foreignIncomeTaxOnBusinessIncome.replace(/[$,]/g, '')) : 0,
          foreignIncomeTaxOnNonBusinessIncome: formData.foreignIncomeTaxOnNonBusinessIncome && formData.foreignIncomeTaxOnNonBusinessIncome !== null ?
            parseFloat(formData.foreignIncomeTaxOnNonBusinessIncome.replace(/[$,]/g, '')) : 0,
          costBasedAdjustmentOfCapitalInterest: formData.costBasedAdjustmentOfCapitalInterest && formData.costBasedAdjustmentOfCapitalInterest !== null ?
            parseFloat(formData.costBasedAdjustmentOfCapitalInterest.replace(/[$,]/g, '')) : 0,
          donationFromAReligiousOrganization: formData.donationFromAReligiousOrganization && formData.donationFromAReligiousOrganization !== null ?
            parseFloat(formData.donationFromAReligiousOrganization.replace(/[$,]/g, '')) : 0,
          beneficiaryNumber: formData.beneficiaryNumber && formData.beneficiaryNumber !== null && formData.beneficiaryNumber !== "" ?
            parseFloat(formData.beneficiaryNumber.replace(/[$,]/g, '')) : undefined,
          consolidatedIndicator: formData.consolidatedIndicator && formData.consolidatedIndicator,
          footNotes: formData.footNotes && formData.footNotes !== '' ? formData.footNotes : undefined,
          optionalTextToPrintOnTheSlip: formData.optionalTextToPrintOnTheSlip && formData.optionalTextToPrintOnTheSlip !== '' ? formData.optionalTextToPrintOnTheSlip : undefined,
        },
        // secondExternalId:
        //   formData.recipientType === 20 &&
        //   selectedSecondRecipientResourceActualIdValue && selectedSecondRecipientResourceActualIdValue?.resourceId
        //     ? selectedSecondRecipientResourceActualIdValue.resourceId
        //     : undefined,
      };


      // submitFlexFields(formData);
      submitFlexFields(requestPayload);
    }
  };

  const onResetClicked = () => {
    setSnackbarData({
      open: true,
      message: "Form was reset successfully",
      severity: "success",
    });
    formMethods.reset();
    formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
    setSlipOtherInformation([])
    setSelectedResourceSlipList([{ label: "Create New", value: "create-new" }]);
    setSelectedResourceSlip("create-new");
    setSelectedOtherInformation(false);
    setSelectedResource("create-new");
    setSelectedCard(null);
    let path = `/taxslip/rl16/setup`;
    navigate(path);
    setRL16SlipRecord(undefined);
  };

  // For Delete Row

  const { isPending: isDeleting, mutate: deleteRL16SlipById } = useMutation({
    mutationFn: RL16SlipService.delRL16Slip,

    onSuccess: (res: any | IServerError | IResponse) => {

      if (typeof res === "string") {
        // remove the cache of the Year fields since we just added a new field.
        setSnackbarData({
          open: true,
          message: "Record has been deleted successfully.",
          severity: "success",
        });
        setRL16SlipRecord(undefined);
        // refectchRL16SlipIds()
      } else {
        setSnackbarData({
          open: true,
          // message: "Something went wrong, try again later!",
          message: res.message,
          severity: "error",
        });
      }

      //load Employee Data
      if (res) {
        const selectedVendor = formMethods.getValues("selectedVendor");

        if (selectedVendor !== "create-new") {
          let path = `/taxslip/rl16/setup/${selectedVendor}`;
          navigate(path);
          const fetchData = async () => {
            try {
              const response: any =
                await RL16SlipService.getResourceSlipDropDownList(
                  selectedVendor,
                  clientId,
                  taxYear
                );

              if (response && Array.isArray(response)) {
                let resourceSlipList: IDropDownListResponse[] =
                  response.map((resourceSlip: IDropDownListResponse) => ({
                    label: resourceSlip.label,
                    value: resourceSlip.value,
                  }));

                resourceSlipList.unshift({
                  label: "Create New",
                  value: "create-new",
                });


                setSelectedResourceSlipList(resourceSlipList);
                formMethods.setValue(
                  "selectedSlip",
                  resourceSlipList[0].value
                );
                createNewActionFromSlipDDL();
              }
            } catch (error) {
              console.error("Error fetching data:", error);
            }
          };

          fetchData();
        }
      }
      selectedRL16SlipType = formMethods.getValues("slipType");
      setSelectedOtherInformation(true);
    },
    onError: (err: any) => {
      setSnackbarData({
        open: true,
        message: err.message,
        severity: "error",
      });
    },
  }
  );

  const deleteRL16SlipField = () => {
    if (singleDelete) {
      let payload = {
        RL16SlipId,
        clientId,
        taxYear,
      };
      setSingleDelete(false);
      deleteRL16SlipById(payload);
      setDialogOpen(false);
    }
  };

  const onDeleteClicked = () => {
    setDialogOpen(true);
    setSingleDelete(true);
    setApiAction("delete");
    if (
      selectedRL16SlipsData &&
      selectedRL16SlipsData.resource
    ) {
      setRL16SlipId(selectedRL16SlipsData.id);
    }
  };

  const savePdfAsFile = (pdfData: any, filename: any) => {
    const blob = new Blob([pdfData], { type: "pdf;charset=utf-8" });
    FileSaver.saveAs(blob, filename);
  };
  const onPrintClicked = async (): Promise<void> => {
    // const maskedStatus: any = sessionStorage.getItem("maskEnabled");
    if (dashboardApiData.masked_status) {
      setIsLoadingData(false);
      setSnackbarData({
        open: true,
        message: "Please unmask your data.",
        severity: "error",
      });
    } else {
      if (invoicePaymentFor === 10) {
        try {
          const previousYearInvoiceResponse: any = await ReportsService.getPreviousYearInvoice(
            clientId,
            taxYear - 1
          );
          try {
            const response: any = await ReportsService.createInvoice(
              clientId,
              taxYear
            );
            setIsLoadingData(false);

            if (previousYearInvoiceResponse.message === "Slips not found for invoice." && response.message === "Slips not found for invoice.") {
              try {
                const rl16SlipIdsAndAuditStatus: any =
                  await T4SlipService.getSlipIds("RL16", clientId, taxYear);
                if (rl16SlipIdsAndAuditStatus && rl16SlipIdsAndAuditStatus.generalAuditStatus !== null && rl16SlipIdsAndAuditStatus.generalAuditStatus === true &&
                  rl16SlipIdsAndAuditStatus && rl16SlipIdsAndAuditStatus.auditStatus !== null && rl16SlipIdsAndAuditStatus.auditStatus === true) {
                  setIsLoadingData(true);
                  try {
                    // const response: any = await PrintingService.createSingleRL16PdfPrint(clientId, EditedResourceId, formMethods.getValues("slipType"), taxYear);
                    let pdfIds = `rl16_slip_ids=${id}`;
                    const response: any =
                      await PrintingService.createBulkRL16PdfPrint(
                        clientId,
                        pdfIds,
                        taxYear
                      );
                    if (response.status === 400) {
                      setSnackbarData({
                        open: true,
                        message: response.data.message
                          ? response.data.message
                          : "Something went wrong.",
                        // message: "Please Unmask sensitive data for PDF printing.",
                        severity: "error",
                      });
                    } else {
                      const filename = `RL16slip-${clientName}.pdf`;
                      savePdfAsFile(response, filename);
                    }
                    setIsLoadingData(false);
                  } catch (err) {

                    // alert(err)
                  }
                  // }
                  setIsLoadingData(false);
                } else {
                  setIsLoadingData(false);
                  setSnackbarData({
                    open: true,
                    message: (
                      <>
                        Please load Audit in the menu, press Run RL-16 Audit and clear all audit items to generate documents.{" "}
                        <a
                          href="https://appv3.taxslips.com/#/audit/filing"
                          style={{
                            color: "#aa1010",
                            textDecoration: "none",
                            fontWeight: "bold",
                          }}
                        >
                          Click here to view
                        </a>
                      </>
                    ),
                    severity: "error",
                    autoHide: false,
                  });
                }
              } catch (err: any) {
                setIsLoadingData(false);
              }
            } else if (
              response?.id != null &&
              previousYearInvoiceResponse?.id != null
            ) {

              setInvoiceData([previousYearInvoiceResponse, response]);
              setInvoiceDialogOpen(true);
            } else if (
              previousYearInvoiceResponse?.id != null &&
              response?.message === "Slips not found for invoice."
            ) {

              setInvoiceData([previousYearInvoiceResponse]);
              setInvoiceDialogOpen(true);
            } else if (
              response?.id != null &&
              previousYearInvoiceResponse?.message === "Slips not found for invoice."
            ) {

              setInvoiceData([response]);
              setInvoiceDialogOpen(true);
            } else {
              setSnackbarData({
                open: true,
                message: "Something went wrong.",
                severity: "error",
              });
            }
            setIsLoadingData(false);
          } catch (err) {

            setIsLoadingData(false);
          }
        } catch (err) {

          setIsLoadingData(false);
        }
      } else {
        setIsLoadingData(true);
        try {
          const response: any = await ReportsService.createInvoice(
            clientId,
            taxYear
          );
          setIsLoadingData(false);

          if (response.message === "Slips not found for invoice.") {
            // setIsLoadingData(true);
            // try {
            //   const filingAuditResponse: any =
            //     await RL16SlipService.getRL16AuditFiling(clientId, taxYear);

            //   if (
            //     filingAuditResponse &&
            //     filingAuditResponse.general_filling &&
            //     filingAuditResponse.general_filling.length > 0
            //   ) {
            //    
            //     setSnackbarData({
            //       open: true,
            //       message: (
            //         <>
            //           Please load Audit in the menu and clear all audit items
            //           (Audit Filing and PIER Review) to generate documents.{" "}
            //           <a
            //             href="https://appv3.taxslips.com/#/audit/filing"
            //             style={{
            //               color: "#aa1010",
            //               textDecoration: "none",
            //               fontWeight: "bold",
            //             }}
            //           >
            //             Click here to view
            //           </a>
            //         </>
            //       ),
            //       severity: "error",
            //       autoHide: false,
            //     });
            //   } else if (
            //     filingAuditResponse &&
            //     filingAuditResponse.rl16_filling &&
            //     filingAuditResponse.rl16_filling.length > 0
            //   ) {
            //   
            //     setSnackbarData({
            //       open: true,
            //       message: (
            //         <>
            //           Please load Audit in the menu and clear all audit items
            //           (Audit Filing and PIER Review) to generate documents.{" "}
            //           <a
            //             href="https://appv3.taxslips.com/#/audit/filing"
            //             style={{
            //               color: "#aa1010",
            //               textDecoration: "none",
            //               fontWeight: "bold",
            //             }}
            //           >
            //             Click here to view
            //           </a>
            //         </>
            //       ),
            //       severity: "error",
            //       autoHide: false,
            //     });
            //   } else {
            //     setIsLoadingData(true);
            try {
              const rl16SlipIdsAndAuditStatus: any =
                await T4SlipService.getSlipIds("RL16", clientId, taxYear);
              if (rl16SlipIdsAndAuditStatus && rl16SlipIdsAndAuditStatus.generalAuditStatus !== null && rl16SlipIdsAndAuditStatus.generalAuditStatus === true &&
                rl16SlipIdsAndAuditStatus && rl16SlipIdsAndAuditStatus.auditStatus !== null && rl16SlipIdsAndAuditStatus.auditStatus === true) {
                setIsLoadingData(true);
                try {
                  // const response: any = await PrintingService.createSingleRL16PdfPrint(clientId, EditedResourceId, formMethods.getValues("slipType"), taxYear);
                  let pdfIds = `rl16_slip_ids=${id}`;
                  const response: any =
                    await PrintingService.createBulkRL16PdfPrint(
                      clientId,
                      pdfIds,
                      taxYear
                    );
                  if (response.status === 400) {
                    setSnackbarData({
                      open: true,
                      message: response.data.message
                        ? response.data.message
                        : "Something went wrong.",
                      // message: "Please Unmask sensitive data for PDF printing.",
                      severity: "error",
                    });
                  } else {
                    const filename = `RL16slip-${clientName}.pdf`;
                    savePdfAsFile(response, filename);
                  }
                  setIsLoadingData(false);
                } catch (err) {

                  // alert(err)
                }
                // }
                setIsLoadingData(false);
              } else {
                setIsLoadingData(false);
                setSnackbarData({
                  open: true,
                  message: (
                    <>
                      Please load Audit in the menu, press Run RL-16 Audit and clear all audit items to generate documents.{" "}
                      <a
                        href="https://appv3.taxslips.com/#/audit/filing"
                        style={{
                          color: "#aa1010",
                          textDecoration: "none",
                          fontWeight: "bold",
                        }}
                      >
                        Click here to view
                      </a>
                    </>
                  ),
                  severity: "error",
                  autoHide: false,
                });
              }
            } catch (err: any) {
              setIsLoadingData(false);
            }
          } else if (response && response.id !== null) {
            setInvoiceData([response]);
            setInvoiceDialogOpen(true);
          } else {
            setSnackbarData({
              open: true,
              message: "Something went wrong.",
              severity: "error",
            });
          }
        } catch (err) {

          setIsLoadingData(false);
        }
      }
    }
  };

  const onUnPaidClickHandler = (clickedRow: any, tag: string) => {
    setIsLoadingData(true);
    // setTimeout(() => {
    //   setIsLoadingData(false);
    // }, 2500);
    const fetchData = async () => {
      try {
        const response: any =
          await ReportsService.paypalIntegrationOfUnpaidInvoice(
            clientId,
            clickedRow.refNo,
            tag
          );
        setIsLoadingData(false);

        if (tag === 'paypal') {
          window.open(response, '_blank');
        } else {
          window.open(response.message, '_blank');
        }
      } catch (error) {
        setIsLoadingData(false);
        console.error("Error fetching data:", error);
      } finally {
        setIsLoadingData(false);
      }
    }
    fetchData();

  };

  const onClickInvoiceNoHandler = (clickedRow: any) => {
    dispatch(setSelectedINVOICE(clickedRow));

  };
  /**
   * On Snackbar closed.
   *
   * @param {React.SyntheticEvent | Event} event
   * @param {string} reason
   */
  const onSnackbarClosed = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarData(INITIAL_SNACKBAR_DATA);
  };

  const onResourceSelectionChangeHandler = async (
    selectedItem: IEnhancedDropDownItem | any,
    index?: any
  ): Promise<void> => {
    // setSelectedResource(String(selectedItem.value));

    //this is for card selection
    setSelectedCard(index);
    setSelectedResourceSlip("create-new");
    if (!index) {
      //this is for card selection
      setSelectedCard(selectedItem.value);
      setSelectedResourceSlip("create-new");
    }
    if (selectedItem.value === "create-new") {
      setSnackbarData({
        open: true,
        message: "Please load a payee for RL16 Slip",
        severity: "error",
      });
      setSidePanelsVisibility((prevButtonState: any) => !prevButtonState);
      formMethods.reset();
      formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
      setSlipOtherInformation([])
      //otherinformation will update selected items
      setSelectedOtherInformation(false);
      setSelectedResourceSlipList([
        { label: "Create New", value: "create-new" },
      ]);
      setSelectedResourceSlip("create-new");
      setSelectedOtherInformation(true);
      let path = `/taxslip/rl16/setup`;
      navigate(path);
      setRL16SlipRecord(undefined);
      setSelectedResource("create-new");
    } else {
      // setOnResourceSelectionAPIsCalls(true);
      // formMethods.reset();
      setOnResourceSelectionAPIsCalls(true);
      formMethods.setValue(
        "selectedEmployee",
        selectedItem.value
      );
      setSelectedResource(selectedItem.value);
      (async () => {
        setIsPendingSlipData(true)
        try {
          const response: any =
            await RL16SlipService.getResourceSlipDropDownList(
              selectedItem.value,
              clientId,
              taxYear
            );

          if (response && Array.isArray(response)) {
            let resourceSlipList: IDropDownListResponse[] =
              response.map(
                (resourceSlip: IDropDownListResponse) => ({
                  label: resourceSlip.label,
                  value: resourceSlip.value,
                })
              );

            resourceSlipList.unshift({
              label: "Create New",
              value: "create-new",
            });



            setSelectedResourceSlipList(resourceSlipList);
            if (
              resourceSlipList &&
              resourceSlipList.length > 1
            ) {
              (async () => {
                try {


                  setIsPendingSlipData(true)
                  let slipDataById =
                    await RL16SlipService.getRL16SlipById(
                      String(resourceSlipList[1].value),
                      clientId,
                      taxYear
                    );
                  setRL16SlipRecord(slipDataById)
                  setSelectedResourceSlip(
                    String(resourceSlipList[1].value)
                  );
                  formMethods.setValue(
                    "selectedSlip",
                    String(resourceSlipList[1].value)
                  );
                  slipDataByIdPass(slipDataById, true);

                  //set slip type to 400 because when we come back to slip without reload it will automatically be original
                  selectedRL16SlipType =
                    formMethods.getValues("slipType");
                  // //otherinformation will update sselected items when its submitted
                  setSelectedOtherInformation(true);
                } catch (error) {
                  setIsPendingSlipData(false);
                  console.error(
                    "Error fetching data:",
                    error
                  );
                }
              })();
            } else {
              (async () => {
                try {
                  setIsPendingSlipData(true);
                  let resourceDataById =
                    await RL16SlipService.getResourceInformationById(
                      selectedItem.value,
                      clientId,
                      T3_BENEFICIARY_RESOURCE_LITERAL
                    );
                  resourceDataByIdPass(resourceDataById)
                } catch (error) {
                  setIsPendingSlipData(false);
                  console.error("Error fetching data:", error);
                }
              })();
              setRL16SlipRecord(undefined)
              setSelectedResourceSlip("create-new");
              // formMethods.setValue(
              //   "selectedSlip",
              //   "create-new"
              // );
              // formMethods.setValue(
              //   "capitalGains",
              //   "0.00"
              // );
              // formMethods.setValue(
              //   "singlePensionPayment",
              //   "0.00"
              // );
              // formMethods.setValue(
              //   "actualAmountOfEligibleDivinends",
              //   "0.00"
              // );
              // formMethods.setValue(
              //   "actualAmountOfDivinendsOtherThanEligible",
              //   "0.00"
              // );
              // formMethods.setValue(
              //   "pensionPaymentGivingEntitlement",
              //   "0.00"
              // );
              // formMethods.setValue(
              //   "foreignBusinessIncome",
              //   "0.00"
              // );
              // formMethods.setValue(
              //   "foreignNonBusinessIncome",
              //   "0.00"
              // );
              // formMethods.setValue(
              //   "otherIncome",
              //   "0.00"
              // );
              // formMethods.setValue(
              //   "capitalGainGivingEntitlement",
              //   "0.00"
              // );
              // formMethods.setValue(
              //   "taxableAmountOfEligibleAndOrdinaryDividends",
              //   "0.00"
              // );
              // formMethods.setValue(
              //   "dividendTaxCredit",
              //   "0.00"
              // );
              // formMethods.setValue(
              //   "foreignIncomeTaxOnBusinessIncome",
              //   "0.00"
              // );
              // formMethods.setValue(
              //   "foreignIncomeTaxOnNonBusinessIncome",
              //   "0.00"
              // );
              // formMethods.setValue(
              //   "costBasedAdjustmentOfCapitalInterest",
              //   "0.00"
              // );
              // formMethods.setValue(
              //   "donationFromAReligiousOrganization",
              //   "0.00"
              // );
              // formMethods.setValue(
              //   "beneficiaryNumber",
              //   ""
              // );
              // formMethods.setValue(
              //   "consolidatedIndicator",
              //   'C'
              // );
              // formMethods.setValue("footNotes", "");
              // formMethods.setValue(
              //   "optionalTextToPrintOnTheSlip",
              //   ""
              // );
              // formMethods.setValue("slipStatus", 200);
              // formMethods.setValue("comparison", []);
              // setSlipOtherInformation([{ amount: 0, code: 'null', label: 'Empty Field' }])
              // createNewActionFromSlipDDL()
              setSelectedResource(
                String(
                  selectedItem.value
                )
              );
              setEditedResourceId(
                String(
                  selectedItem.value
                )
              );
              let path = `/taxslip/rl16/setup/${selectedItem.value}`;
              navigate(path);
            }
          }
        } catch (error) {
          setIsPendingSlipData(false)
          console.error("Error fetching data:", error);
        }
      })();



    }
    setSelectedOtherInformation(false);
  };

  const onResourceSlipSelectionChangeHandler = (
    selectedItem: IEnhancedDropDownItem | any
  ) => {
    setOnResourceSelectionAPIsCalls(true);
    if (selectedItem.value === "create-new") {
      createNewActionFromSlipDDL();
      setSelectedResourceSlip("create-new");
      if (selectedResource !== "create-new") {
        setOnResourceSelectionAPIsCalls(true);
        let path = `/taxslip/rl16/setup/${selectedResource}`;
        navigate(path);
      }
      setRL16SlipRecord(undefined);
    }
    if (selectedItem.value !== "create-new") {
      (async () => {
        try {
          setIsLoadingAdjustedData(true);
          let slipDataById = await RL16SlipService.getRL16SlipById(
            String(selectedItem.value),
            clientId,
            taxYear
          );
          setRL16SlipRecord(slipDataById)
          slipDataByIdPass(slipDataById, true);
          selectedRL16SlipType = formMethods.getValues("slipType");
          setSelectedOtherInformation(false);
        } catch (error) {
          setIsLoadingAdjustedData(false);
          console.error("Error fetching data:", error);
        }
      })();
    }
  };

  // const { isPending: isLoadingGlobalVariables, data: editDataRecord } =
  //   useGetGlobalVariables(taxYear);
  // const globalVariablesData: any = editDataRecord;

  // const { isPending: loadingSlipIds, data: rl16SlipIds, refetch: refectchRL16SlipIds } = useGetSlipIds("RL16", clientId, taxYear);

  // const { isPending: isLoadingClientDataById, data: companyGetByIdRecord } =
  //   useGetCompanyData(clientId);

  useEffect(() => {

    if (dashboardApiData && dashboardApiData.client_detail && dashboardApiData.client_detail && dashboardApiData.client_detail.metaFields) {
      const paymentFor = dashboardApiData.client_detail.metaFields.find((item: any) => item.name === 'invoice_payment_for')

      setInvoicePaymentFor(paymentFor ? parseInt(paymentFor.value) : 10)
    }
  }, [dashboardApiData])



  // for edit

  //if slip is completed this will effected
  useEffect(() => {
    if (RL16SlipRecord && onResourceSelectionAPIsCalls === false) {
      slipDataByIdPass(RL16SlipRecord, onResourceSelectionAPIsCalls);
    }
    selectedRL16SlipType = formMethods.getValues("slipType");
  }, [RL16SlipRecord, formMethods.setValue, formMethods, onResourceSelectionAPIsCalls]);

  //this is for not started slip
  useEffect(() => {
    // if the selected flex field data has loaded.
    if (selectedNotStartedResourceData && onResourceSelectionAPIsCalls === false) {
      resourceDataByIdPass(selectedNotStartedResourceData);
    }
  }, [selectedNotStartedResourceData, formMethods.setValue, formMethods, onResourceSelectionAPIsCalls]);

  // useEffect(() => {
  //   //Load RL16 Recipient DDL
  //   if (RL16SlipRecord) {
  //     // const fetchData = async () => {
  //     //   try {
  //     //     setIsLoadingAdjustedData(true);
  //     //     const response: any =
  //     //       await RL16SlipService.getRL16RecipientDDLByRecipientType(
  //     //         clientId,
  //     //         T3_BENEFICIARY_RESOURCE_LITERAL,
  //     //         taxYear,
  //     //         RL16SlipRecord.recipientType
  //     //       );
  //     //     if (response && Array.isArray(response)) {
  //     //       let resources: IDropDownListResponse[] = response.map(
  //     //         (resourceItem: IDropDownListResponse) => ({
  //     //           label: resourceItem.label,
  //     //           value: resourceItem.value,
  //     //         })
  //     //       );
  //     //       resources.unshift({
  //     //         label: "Create New",
  //     //         value: "create-new",
  //     //       });
  //     //       setSelectedResourceList(resources);
  //     //     }
  //     //     setResourceListWithoutCreateNew(sortData(response));
  //     //   } catch (error) {
  //     //     console.error("Error fetching data:", error);
  //     //     setIsLoadingAdjustedData(false);
  //     //   } finally {
  //     //     setIsLoadingAdjustedData(false);
  //     //   }
  //     // };
  //     // fetchData();
  //     queryClient.invalidateQueries({
  //       queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId,
  //         T3_BENEFICIARY_RESOURCE_LITERAL,
  //         taxYear,
  //         RL16SlipRecord.recipientType],
  //     });
  //   } else if (selectedNotStartedResourceData) {
  //     selectedNotStartedResourceData?.metaFields.forEach((field: any) => {
  //       if (field.name === "recipientType") {
  //         let recipientTypeValue = parseInt(field.value);
  //         // const fetchData = async () => {
  //         //   try {
  //         //     setIsLoadingAdjustedData(true);
  //         //     const response: any =
  //         //       await RL16SlipService.getRL16RecipientDDLByRecipientType(
  //         //         clientId,
  //         //         T3_BENEFICIARY_RESOURCE_LITERAL,
  //         //         taxYear,
  //         //         recipientTypeValue
  //         //       );
  //         //     if (response && Array.isArray(response)) {
  //         //       let resources: IDropDownListResponse[] = response.map(
  //         //         (resourceItem: IDropDownListResponse) => ({
  //         //           label: resourceItem.label,
  //         //           value: resourceItem.value,
  //         //         })
  //         //       );
  //         //       resources.unshift({
  //         //         label: "Create New",
  //         //         value: "create-new",
  //         //       });
  //         //       setSelectedResourceList(resources);
  //         //     }
  //         //     setResourceListWithoutCreateNew(sortData(response));
  //         //   } catch (error) {
  //         //     console.error("Error fetching data:", error);
  //         //     setIsLoadingAdjustedData(false);
  //         //   } finally {
  //         //     setIsLoadingAdjustedData(false);
  //         //   }
  //         // };
  //         // fetchData();
  //         queryClient.invalidateQueries({
  //           queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId,
  //             T3_BENEFICIARY_RESOURCE_LITERAL,
  //             taxYear,
  //             recipientTypeValue],
  //         });
  //       }
  //     });
  //   }
  //   // else {
  //   // const recipientType = formMethods.getValues("recipientType");
  //   // const fetchData = async () => {
  //   //   try {
  //   //     setIsLoadingAdjustedData(true);
  //   //     const response: any =
  //   //       await RL16SlipService.getRL16RecipientDDLByRecipientType(
  //   //         clientId,
  //   //         T3_BENEFICIARY_RESOURCE_LITERAL,
  //   //         taxYear,
  //   //         recipientType
  //   //       );
  //   //     if (response && Array.isArray(response)) {
  //   //       let resources: IDropDownListResponse[] = response.map(
  //   //         (resourceItem: IDropDownListResponse) => ({
  //   //           label: resourceItem.label,
  //   //           value: resourceItem.value,
  //   //         })
  //   //       );
  //   //       resources.unshift({
  //   //         label: "Create New",
  //   //         value: "create-new",
  //   //       });
  //   //       setSelectedResourceList(resources);
  //   //     }
  //   //     setResourceListWithoutCreateNew(sortData(response));
  //   //   } catch (error) {
  //   //     console.error("Error fetching data:", error);
  //   //     setIsLoadingAdjustedData(false);
  //   //   } finally {
  //   //     setIsLoadingAdjustedData(false);
  //   //   }
  //   // };
  //   // fetchData();
  //   //   queryClient.invalidateQueries({
  //   //     queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId,
  //   //       T3_BENEFICIARY_RESOURCE_LITERAL,
  //   //       taxYear,
  //   //       recipientType],
  //   //   });
  //   // }
  // }, [RL16SlipRecord, selectedNotStartedResourceData, formMethods]);

  // when  I formMethods.setValue of otherinformation inside async calls method then facing issue while click on add more so we have to use state method to show otherinformation 
  useEffect(() => {

    if (
      slipOtherInformation &&
      slipOtherInformation !== null &&
      slipOtherInformation.length !== 0
    ) {

      setOiInEdit(true);
      formMethods.setValue(
        "comparison",
        slipOtherInformation
      );
    } else if (!id) {

      setOiInEdit(true);
      formMethods.setValue(
        "comparison",
        [
          {
            amount: 0,
            code: "",
            label: "",
          },
        ]
      );
    }
  }, [slipOtherInformation])

  const onSlipTypeSelectionChangeHandler = (e: any) => {
    setIsLoadingAdjustedData(true);
    setTimeout(() => {
      setIsLoadingAdjustedData(false);
    }, 1000);
    const selectedType = e.value;
    selectedRL16SlipType = selectedType;
    // alert(selectedType);
  };

  const onCloseHandler = () => {
    setDialogOpen(false);
    setInvoiceDialogOpen(false);
  };



  const getCardStyles = (index: any) => {
    return {
      borderLeft:
        selectedCard === index ? "6px solid #0057db" : "2px solid transparent",
      cursor: "pointer",
    };
  };
  const getSelectedResourceSlipInCard = (index: any) => {
    let selectedItem =
      selectedCard === index ? selectedResourceSlip : "create-new";
    return selectedItem;
  };
  const getSelectedResourceSlipsListInCard = (index: any) => {
    let selectedList =
      selectedCard === index
        ? selectedResourceSlipList
        : [{ label: "Create New", value: "create-new" }];
    return selectedList;
  };

  const filteredResourceList =
    resourceListWithoutCreateNew &&
    resourceListWithoutCreateNew.filter((item: any) =>
      item.label.toLowerCase().includes(itemSearch.toLowerCase())
    );

  const onCreateNewButtonClicked = () => {
    setSnackbarData({
      open: true,
      message: "Please load a payee for RL16 Slip",
      severity: "error",
    });
    formMethods.reset();
    formMethods.setValue("comparison", [{ amount: 0, code: "", label: "" }]);
    //otherinformation will update selected items
    setSelectedOtherInformation(false);
    setSelectedResourceSlipList([{ label: "Create New", value: "create-new" }]);
    setSlipOtherInformation([])
    setSelectedResourceSlip("create-new");
    let path = `/taxslip/rl16/setup`;
    navigate(path);
    setRL16SlipRecord(undefined);
    setIsLoadingAdjustedData(true);
    setTimeout(() => {
      setIsLoadingAdjustedData(false);
    }, 1000);
    setSelectedResource("create-new");
    setSelectedOtherInformation(false);
    setSelectedCard(null);
  };
  const onDividerButtonClickHandler = () => {
    setSidePanelsVisibility((prevButtonState: any) => !prevButtonState);
  };
  const onIndividualSelectionChangeHandler = (value: boolean) => {
    formMethods.setValue("secondRecipientName", undefined);
    if (value === true) {
      (async () => {
        try {
          setIsLoadingAdjustedData(true);
          const response: any =
            await RL16SlipService.getRL16RecipientDDLByRecipientType(
              clientId,
              T3_BENEFICIARY_RESOURCE_LITERAL,
              taxYear,
              10
            );

          setSecondRecipientDDL(response);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setIsLoadingAdjustedData(false);
        }
      })();
      // queryClient.invalidateQueries({
      //   queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId,
      //     T3_BENEFICIARY_RESOURCE_LITERAL,
      //     taxYear,
      //     10],
      // });
    } else if (value === false) {
      (async () => {
        try {
          setIsLoadingAdjustedData(true);
          const response: any =
            await RL16SlipService.getRL16RecipientDDLByRecipientType(
              clientId,
              T3_BENEFICIARY_RESOURCE_LITERAL,
              taxYear,
              30
            );

          setSecondRecipientDDL(response);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setIsLoadingAdjustedData(false);
        }
      })();
      // queryClient.invalidateQueries({
      //   queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId,
      //     T3_BENEFICIARY_RESOURCE_LITERAL,
      //     taxYear,
      //     30],
      // });
    }
  };
  // useEffect(() => {
  //   const individual = formMethods.getValues("individual");

  //   if (individual === false) {
  //     // (async () => {
  //     //   try {
  //     //     setIsLoadingAdjustedData(true);
  //     //     const response: any =
  //     //       await RL16SlipService.getRL16RecipientDDLByRecipientType(
  //     //         clientId,
  //     //         T3_BENEFICIARY_RESOURCE_LITERAL,
  //     //         taxYear,
  //     //         30
  //     //       );

  //     //     setSecondRecipientDDL(response);
  //     //   } catch (error) {
  //     //     console.error("Error fetching data:", error);
  //     //   } finally {
  //     //     setIsLoadingAdjustedData(false);
  //     //   }
  //     // })();
  //     queryClient.invalidateQueries({
  //       queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId,
  //         T3_BENEFICIARY_RESOURCE_LITERAL,
  //         taxYear,
  //         30],
  //     });

  //   } else if (individual === true) {
  //     // (async () => {
  //     //   try {
  //     //     setIsLoadingAdjustedData(true);
  //     //     const response: any =
  //     //       await RL16SlipService.getRL16RecipientDDLByRecipientType(
  //     //         clientId,
  //     //         T3_BENEFICIARY_RESOURCE_LITERAL,
  //     //         taxYear,
  //     //         10
  //     //       );

  //     //     setSecondRecipientDDL(response);
  //     //   } catch (error) {
  //     //     console.error("Error fetching data:", error);
  //     //   } finally {
  //     //     setIsLoadingAdjustedData(false);
  //     //   }
  //     // })();

  //     queryClient.invalidateQueries({
  //       queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId,
  //         T3_BENEFICIARY_RESOURCE_LITERAL,
  //         taxYear,
  //         10],
  //     });
  //   }
  // }, [formMethods]);

  // let foreignCurrencyDDL = [
  //   {
  //     label: "AFG",
  //     value: "AFG",
  //     name: "Afghanistan",
  //   },
  //   {
  //     label: "CAN",
  //     value: "CAN",
  //     name: "Canada",
  //   },
  //   {
  //     label: "PAK",
  //     value: "PAK",
  //     name: "Pakistan",
  //   },
  // ];

  // useEffect(() => {
  //   const recipientType = formMethods.getValues("recipientType");

  //   setRecipientTypeValue(recipientType);
  // }, [formMethods]);


  useEffect(() => {
    dispatch(
      setSelectedActivityLogActions({
        entityId1: id ? id : "",
        entityId2: "",
        entityId3: "",
        screenName: RL16_SETUP_SCREEN_SLUG,
        companyName: clientName,
        activityType: "activity_type=create&activity_type=updated&activity_type=print&activity_type=delete",
        activityLogVisibility: true,
      })
    );
    dispatch(setSelectedStickyNavBar({ isSticky: true }));
  }, []);

  const [RL16OtherInformationList, setRL16OtherInformationList] =
    useState<any>(undefined);
  useEffect(() => {
    //Load OtherInformationList
    setIsLoadingAdjustedData(true);
    setTimeout(() => {
      setIsLoadingAdjustedData(false);
    }, 2000);
    const fetchData = async () => {
      try {
        const response: any = await RL16OtherInformationService.getRL16OI();
        setRL16OtherInformationList(response);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Grid
        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
        sx={{
          pb: "5rem",
          "& .MuiAppBar-root": { zIndex: 2, top: "65px" },
          "& .p-datepicker": { zIndex: 2 },
          paddingTop: "2rem",
        }}
      >
        <BackdropCircularProgress
          open={
            isSubmitting ||
            isLoadingData ||
            isLoadingAdjustedData ||
            isDeleting ||
            isLoadingNotStartedSlipId ||
            isLoadingDataa ||
            isLoadingForeignCurrencyDDL ||
            isPendingEmployeeDDLItems ||
            isLoadingActivityLogData
          }
          testId={testId}
        />
        <DeleteConfirmationDialog
          open={openDialog}
          deleteActionHandler={deleteRL16SlipField}
          cancelActionHandler={onCloseHandler}
          testId="T4-confirmation-dialog"
        />
        <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
          {sidePanelsVisibility && (
            <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }}>
              <Box sx={{ margin: "0" }}>
                <InputText
                  value={itemSearch}
                  onChange={(e) => setItemSearch(e.target.value)}
                  placeholder={"Search by name..."}
                  className="w-full search-field"
                />
                <Box sx={{ display: "flex", justifyContent: "end" }}>
                  <Button
                    variant="contained"
                    sx={{ right: 0, margin: "10px 0px", fontSize: "12px" }}
                    onClick={onCreateNewButtonClicked}
                  >
                    + Create New
                  </Button>
                </Box>
              </Box>
              <Box
                sx={{
                  // display: "flex",
                  height: "78rem",
                  // flexDirection: "column",
                  overflow: "auto",
                  "&::-webkit-scrollbar": {
                    width: "0.4em",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#ccc",
                    borderRadius: "3px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#aaa",
                  },
                }}
              >
                {resourceListWithoutCreateNew &&
                  filteredResourceList.map((item: any, index: any) => {
                    return (
                      <Card
                        sx={{
                          padding: 0,
                          borderRadius: "8px",
                          marginBottom: "1rem",
                        }}
                        key={index}
                        onClick={() =>
                          onResourceSelectionChangeHandler(item, item.value)
                        }
                        style={getCardStyles(item.value)}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "0.8rem",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{ fontWeight: "bold", fontSize: ".875rem" }}
                          >
                            {item.label}
                          </Typography>
                          <Avatar
                            shape="circle"
                            style={{
                              background: "#0057db",
                              color: "#fff",
                              borderRadius: "50%",
                              fontWeight: "bold",
                              fontSize: ".775rem",
                              padding: "2px",
                            }}
                          >
                            {item.label
                              .replace(/\s+/g, " ")
                              .split(" ")
                              .filter((word: string) => word.trim() !== "")
                              .map((word: string) => word[0].toUpperCase())
                              .slice(0, 2)
                              .join("")}
                          </Avatar>
                        </Box>
                        {selectedCard === item.value ? (
                          <>
                            <Divider className="m-0" />
                            <Box>
                              <Box sx={{ padding: "0.6rem" }}>
                                <Dropdown
                                  value={getSelectedResourceSlipInCard(
                                    item.value
                                  )}
                                  onChange={
                                    onResourceSlipSelectionChangeHandler
                                  }
                                  options={getSelectedResourceSlipsListInCard(
                                    item.value
                                  )}
                                  onClick={(e: any) => e.stopPropagation()}
                                  className="slip-dropdown"
                                />
                              </Box>
                            </Box>
                          </>
                        ) : (
                          <></>
                        )}
                      </Card>
                    );
                  })}
              </Box>
            </Grid>
          )}
          <Divider
            layout="vertical"
            align="center"
            className="verticle-divider"
            style={{ zIndex: 0 }}
          >
            <Button
              variant="outlined"
              sx={{
                minWidth: "fit-content",
                padding: "20px 0",
                borderRadius: "7px",
              }}
              onClick={onDividerButtonClickHandler}
            >
              {sidePanelsVisibility ? (
                <i
                  className="pi pi-angle-double-left"
                  style={{ color: "#0057db" }}
                ></i>
              ) : (
                <i
                  className="pi pi-angle-double-right"
                  style={{ color: "#0057db" }}
                ></i>
              )}
            </Button>
          </Divider>
          <Grid
            size={{
              xs: sidePanelsVisibility ? 8 : 10,
              sm: sidePanelsVisibility ? 8 : 10.8,
              md: sidePanelsVisibility ? 9.4 : 11.2,
              lg: sidePanelsVisibility ? 9.5 : 11.6,
              xl: sidePanelsVisibility ? 9.7 : 11.7
            }}
            sx={{ "& .MuiGrid-container": { marginTop: 0 } }}
          >
            <FormProvider {...formMethods}>
              <form onSubmit={formMethods.handleSubmit(onSubmit)}>
                <TwoColumnLayout
                  toolbar={
                    <RL16SlipSetupToolbar
                      onResetClicked={onResetClicked}
                      onDeleteClicked={onDeleteClicked}
                      onPrintClicked={onPrintClicked}
                      isSubmitting={isSubmitting}
                      formMethods={formMethods}
                    />
                  }
                  leftColumnContent={
                    <>
                      {!sidePanelsVisibility && (
                        <StandardPanel
                          title="Load Slips"
                          testId={`${testId}-load-slips-panel`}
                        >
                          <Grid
                            container
                            columnSpacing={2}
                            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                          >
                            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                              <EnhancedDropDownRHFWithLabel
                                label="Load RL16 Recipient"
                                selectName="selectedVendor"
                                items={selectedResourceList}
                                selectedItem={selectedResource}
                                onSelectionChangeHandler={
                                  onResourceSelectionChangeHandler
                                }
                                testId={`${testId}-selected-vendor`}
                              />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
                              <EnhancedDropDownRHFWithLabel
                                label="Load RL16 Slip"
                                selectName="selectedSlip"
                                items={selectedResourceSlipList}
                                selectedItem={selectedResourceSlip}
                                onSelectionChangeHandler={
                                  onResourceSlipSelectionChangeHandler
                                }
                                testId={`${testId}-selected-slip`}
                              />
                            </Grid>
                          </Grid>
                        </StandardPanel>
                      )}
                      <StandardPanel
                        title="Slip Data"
                        testId={`${testId}-slip-data`}
                        topPadding={!sidePanelsVisibility ? 2 : 0}
                      >
                        {RL16OtherInformationList && (
                          <RL16SlipDataPanel
                            formMethods={formMethods}
                            testId={testId}
                            isLoading={false}
                            otherInformationList={RL16OtherInformationList}
                            selectedOtherInformation={selectedOtherInformation &&
                              selectedOtherInformation}
                            oiInEdit={oiInEdit}
                            // selectedProvinceOfEmployment={
                            //   selectedProvinceOfEmployment
                            // }
                            // foreignCurrencyDDL={
                            //   foreignCurrencyDDList &&
                            //   foreignCurrencyDDListItems
                            // }
                            globalVariablesData={dashboardApiData.global_variable && dashboardApiData.global_variable}
                          // selectedProvinceOfEmployment={undefined}
                          />
                        )}
                      </StandardPanel>
                    </>
                  }
                  rightColumnContent={
                    <>
                      <StandardPanel
                        title="T3 Beneficiary Info"
                        testId={`${testId}-Vendor-info`}
                      >
                        <VendorInfoSetupFieldsPanel
                          testId={testId}
                          formMethods={formMethods}
                          vendorDDL={secondRecipientDDL && secondRecipientDDL}
                          individualChangeHandler={
                            onIndividualSelectionChangeHandler
                          }
                          isLoading={(value: boolean) =>
                            setIsLoadingAdjustedData(value)
                          }
                          resourceDDLWithRecipientType={(value: any) =>
                            setSelectedResourceList(value)
                          }
                          secondRecipientDDLData={(value: any) => setSecondRecipientDDL(value)}
                          resourceDDLWithoutCreateNewWithRecipientType={(
                            value: any
                          ) => setResourceListWithoutCreateNew(sortData(value))}
                          globalVariablesData={
                            dashboardApiData.global_variable && dashboardApiData.global_variable
                          }
                        />
                      </StandardPanel>
                      <StandardPanel
                        title="Address"
                        testId={`${testId}-Vendor-address-panel`}
                        topPadding={2}
                      >
                        <VendorAddressSetupFieldsPanel testId={testId} />
                      </StandardPanel>
                      <StandardPanel
                        title="Filing Data"
                        testId={`${testId}-filing-data-panel`}
                        topPadding={2}
                      >
                        <EnhancedDropDownRHFWithLabel
                          label="Slip Type"
                          selectName="slipType"
                          items={[
                            { label: "Original", value: 400 },
                            { label: "Amended", value: 200 },
                            { label: "Cancelled", value: 300 },
                            { label: "Additional", value: 100 },
                          ]}
                          selectedItem={400}
                          testId="slip-type"
                          labelPosition={LabelPosition.Left}
                          required
                          onSelectionChangeHandler={
                            onSlipTypeSelectionChangeHandler
                          }
                        />
                        <FilingDataSetupFieldsPanel testId={testId} />
                      </StandardPanel>
                    </>
                  }
                  testId="t4-slip-setup-form"
                />
              </form>
            </FormProvider>
          </Grid>
        </Grid>
        {/* invoice dialogu open if any transaction is unPaid */}
        <EnhancedDialog
          dialogTitle="Invoice(s) Due"
          key="dialog-box"
          testId="dialog"
          onCloseHandler={onCloseHandler}
          open={openInvoiceDialog}
          dialogContent={
            <InvoiceDialogPanel
              invoiceData={invoiceData}
              onUnPaidClickHandler={onUnPaidClickHandler}
              onClickInvoiceNoHandler={onClickInvoiceNoHandler}
            />
          }
          dialogAction={
            <Grid>
              <Button autoFocus variant="contained" onClick={onCloseHandler}>
                Cancel
              </Button>
            </Grid>
          }
        />
        <EnhancedSnackbar
          message={snackbarData.message}
          onCloseHandler={onSnackbarClosed}
          severity={snackbarData.severity}
          testId={`${testId}-snackbar`}
          open={snackbarData.open}
          autoHide={snackbarData.autoHide}
        />
      </Grid>
    </>
  );
};
